import React from 'react'
import { Row, Col, Carousel, ConfigProvider, theme, Image } from 'antd'
import PatientBar from './patient.bar'
import '../../css/measurement.scss'
import _ from 'lodash'

const PatientMeasurement = (props) => {
  var renderGraph = (data) => {
    var activedevices = data?.assigneddevices.filter((dev) => !dev.isDeleted)
    var devicesummary = activedevices?.map((dev) => {
      return {
        ..._.find(data.device_summary, { display_name: dev.display_name }),
        _id: dev.deviceid,
        display_name: dev.display_name,
      }
    })
    return devicesummary?.map((dev, i) => (
      <PatientBar
        pid={props.index}
        index={i}
        data={dev}
        companyUser={props.companyUser}
      />
    ))
  }
  return _.find(props.data?.assigneddevices, { isDeleted: false }) ? (
    <div
      className='measurement'
      onClick={(e) => e.stopPropagation()}
      style={{
        marginTop: '0px',
        width: props.width ? props.width : '100%',
        paddingBottom: 25,
      }}
    >
      <Carousel arrows={true} infinite={true}>
        {renderGraph(props.data)}
      </Carousel>
    </div>
  ) : (
    'NA'
  )
}

export default PatientMeasurement
